import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
CSidebarNavItem,
CModal,
CModalBody,
CModalFooter,
CModalHeader,
CModalTitle
} from "@coreui/react";

import logo from "src/assets/icons/app_logo.png";
import fav from "src/assets/icons/small-logo.png";
import { useHistory } from 'react-router-dom';

import CIcon from "@coreui/icons-react";

// sidebar nav config
import navigation from "./_nav";
import CashPayments from "../views/transactions/cash-payments/CashPayments";
import PurchaseAdd from "src/views/transactions/purchase-add/PurchaseAdd";
import RecieptAdd from "src/views/transactions/receipt-add/ReceiptAdd";
import JournalAdd from "src/views/transactions/journal-add/JournalAdd";
import ProfileView from "src/views/pages/profile/ProfileView";

const TheSidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state?.changeState.sidebarShow);
  const [primary, setPrimary] = useState(false);
  const handleModalOpen = () =>{
    setPrimary(!primary)
    setShowpopUp("")
    }
    const onModalClose = () =>{
     
      setPrimary(!primary)
   
  }
  const [showPopUp, setShowpopUp] = useState()
  const [pathType, setPathType] = useState("")
  const handleRouterEvent = (value, type)=>{
    setPrimary(!primary)
    setTimeout(() => {
      setShowpopUp(value)
      setPathType(type)
    }, 0);
  }

  
  const history = useHistory()
  return (
    <>
     
    {(showPopUp == "create-journal") && <JournalAdd></JournalAdd>}
    {(showPopUp == "create-receipt") && <RecieptAdd></RecieptAdd>}
    {(showPopUp == "cash-payments" || showPopUp == "bank-payments") && <CashPayments popup={true} pathType={pathType} subType={showPopUp}></CashPayments>}
    {showPopUp == "purchase-add" && <PurchaseAdd popup={true} pathType={pathType}></PurchaseAdd>}
    <CSidebar
      show={show}
      onShowChange={(val) => dispatch({ type: "set", sidebarShow: val })}
    >
      <CSidebarBrand className="d-md-down-none" to="/">
       {/* <CIcon
          className="c-sidebar-brand-full"
          name="logo-negative"
          height={35}
        /> */}
         <img src={logo} className="c-sidebar-brand-full" width=""/>{" "}
        {/* <CIcon
          className="c-sidebar-brand-minimized"
          name="sygnet"
          height={35}
        /> */}
        <img src={fav} className="c-sidebar-brand-minimized" width="45"/>
        
        {/* Change dimensions later */}
      </CSidebarBrand>
      <CSidebarNav>
        <div className="pl-3 pr-3 pt-3 pb-3">
{/* 
          <button className="btn btn-outline-dark btn-block btn-md rounded-pill outline-btn-width long-btn bold-label" onClick={() => handleModalOpen()}><i className="fas fa-plus"></i> New</button> */}
{/* 
          <button className="border-0 outline-btn-width minimized bg-dark btn-shadow rounded-pill text-white" onClick={() => handleModalOpen()}><i className="fas fa-plus"></i></button> */}
        </div>  
        <CCreateElement
          items={navigation}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
    <span className="left-modal">
    <CModal 
    show={primary}
    centered
    size="lg"
    onClose={() => onModalClose()}
    color="dark" 
    closeOnBackdrop={true} className="left"
  >
    {/* <CModalHeader closeButton className="p-2">
        <CModalTitle>Add Query</CModalTitle>
    </CModalHeader> */}
    <CModalBody className="text-left less-modal-bold">
        <div className="row">
          <div className="col-md-4 col-4">
            <h6 className="bold-label">Voucher</h6>
            <hr className="hr-light-border mt-2 mb-0"/>
            <ul className="list-group list-group-flush">
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("cash-payments","Payment")}>Cash Payments</li>
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("bank-payments","Payment")}>Bank Payments</li>
              {/* <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("/create-payment")}>Payments</li> */}
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("create-journal")}>Journal</li>
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("create-receipt", "Receipt")}>Receipts</li>
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("purchase-add", "Purchases")}>Purchases</li>
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("purchase-add" , "Sales")}>Sales</li>
              
            </ul>
          </div>
          <div className="col-md-4 col-4">
            <h6 className="bold-label">Ledgers</h6>
            <hr className="hr-light-border mt-2 mb-0"/>
            <ul className="list-group list-group-flush">
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("/sales-order")}>Sales Order</li>
              <li className="list-group-item pl-0 status-font border-bottom-0 pb-0 min-font-size" onClick={()=>handleRouterEvent("/create-group")}>Create Group</li>

            </ul>  
          </div>
          <div className="col-md-4 col-4">
            <h6 className="bold-label">Inventors</h6>
            <hr className="hr-light-border mt-2 mb-0"/>
          </div>
        </div> 
    </CModalBody>
    <CModalFooter className="border-top-0 p-0">
        <button className="btn btn-link text-dark" onClick={()=>setPrimary(!primary)}><i className="fas fa-times"></i> Close</button>
    </CModalFooter>
</CModal>
</span>

</>
  );
};

export default React.memo(TheSidebar);
